<div *onlyForScreens="['desktop', 'tablet']">
  <div
    class="context-dialog position-{{ position }} v-position-{{ verticalPosition }}"
    [class.interactive]="interactive"
    [class.big-border-radius]="options.bigBorderRadius"
    [class.no-spacing]="options.noSpacing"
    [class.double-spacing]="options.doubleSpacing"
    [style.max-width]="options.width"
    [@contextDialog]
    *ngIf="template"
    [style.left]="
      position === 'left' || position === 'left-out' || position === 'center' || position === 'screen-center'
        ? pos.x + 'px'
        : 'auto'
    "
    [style.right]="position === 'right' ? pos.x + 'px' : 'auto'"
    [style.top]="
      verticalPosition === 'bottom' || verticalPosition === 'bottom-in' || verticalPosition === 'center'
        ? pos.y + 'px'
        : 'auto'
    "
    [style.bottom]="verticalPosition === 'top' || verticalPosition === 'top-in' ? pos.y + 'px' : 'auto'"
    #contextMenuContainer
  >
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
</div>

<div *onlyForScreens="['mobile']">
  <div
    class="context-dialog context-menu-mobile"
    [class.no-spacing]="options.noSpacing"
    [style.max-height]="maxHeight + 'px'"
    [class.double-spacing]="options.doubleSpacing"
    [@contextDialogMobile]
    *ngIf="template"
    #contextMenuContainer
  >
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
</div>

<div
  class="context-background {{ options.background }}"
  [class.close-on-bg-click]="options.closeOnBgClick"
  [@contextBackground]
  (click)="!options.openOnHover && close()"
  *ngIf="template && options.background !== 'none'"
></div>
